import { Link } from "react-router-dom";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { faqs } from "@/mocks/faqs";

export default function FaqPreviewSection() {
  const preview = faqs.slice(0, 5);

  return (
    <section id="faq" className="bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
          <div className="lg:col-span-4">
            <p className="text-xs tracking-[0.25em] uppercase text-primary-600 mb-3">常见疑问</p>
            <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-tight">
              投稿前，你最想确认的事
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              如果这里没有你要的答案，可以到完整的问题列表里继续查看，或直接匿名提交你的疑问。
            </p>
            <Link
              to="/faq"
              className="mt-6 inline-flex items-center gap-2 px-5 py-3 rounded-md text-sm font-medium bg-background-50 border border-background-300 text-foreground-800 hover:border-primary-400 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              查看全部问题
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </div>

          <div className="lg:col-span-8">
            <FaqAccordion items={preview} defaultOpen={0} />
          </div>
        </div>
      </div>
    </section>
  );
}